import { BuildingGranulometry } from '../BuildingGranulometry';

export const getBuildingId = (building: BuildingGranulometry) => building.id;
